"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Newline = function (text) {
    return text.replace(/(?:\r\n|\r|\n)/g, "<br />");
};
exports.Newline = Newline;
//# sourceMappingURL=newline.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/helpers/newline.js
// module id = 882
// module chunks = 3